import { render, staticRenderFns } from "./ads-table.vue?vue&type=template&id=5a430006&"
import script from "./ads-table.vue?vue&type=script&lang=js&"
export * from "./ads-table.vue?vue&type=script&lang=js&"
import style0 from "./ads-table.vue?vue&type=style&index=0&id=5a430006&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports